/* jscs:disable requireSpacesInsideJsxExpressionContainers */

import React from 'react';
import PropTypes from 'prop-types';
import { NamespaceConsumer } from '@ux/namespace-component';
import { breakpoints } from './enums';
import Link from '@ux/link';
/**
 * Render backToLogin link.
 *
 * @Constructor
 * @class backToLoginIn
 * @api public
 */
export default class BackLink extends NamespaceConsumer {

  /**
   * Add eventListeners for breakpoints.
   *
   * @api private
   */
  componentDidMount() {
    this.breakpoint(...breakpoints);
    this.setState({
      isLoaded: true
    });
  }

  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */
  componentWillUnmount() {
    this.breakup();
  }

  render() {
    const props = this.props;
    const { href, title, eid } = props;
    const { isLoaded } = this.state;
    const classes = this.classNames(
      this.namespace('back-link'),
      {
        [this.namespace('loaded')]: isLoaded
      });

    if (!href || !title) {
      return null;
    }

    return (
      <div className={ this.namespace('back-link-wrap') }>
        <Link
          href={ href }
          data-eid={ eid }
          className={ classes }>
          { !this.isMobile && title }
        </Link>
      </div>
    );
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */
BackLink.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string,
  eid: PropTypes.string
};

/**
 * Default property definitions.
 *
 * @type {Object}
 * @api public
 */
BackLink.defaultProps = {
  eid: 'uxp.hydra.utility_bar.back_link.click'
};
